<template>
  <v-row dense align="center" no-gutters>
    <v-col cols="3">
      <v-text-field
        dense
        outlined
        v-model="form.domain"
        label="Domain"
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-radio-group v-model="type" row>
        <v-radio value="admin" label="Change Admin Contact"></v-radio>
        <v-radio value="billing" label="Change Billing Contact"></v-radio>
        <v-radio value="tech" label="Change Tech Contact"></v-radio>
        <v-radio value="all" label="Change Admin, Billing, Tech Contact"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12">
      <v-radio-group v-model="contactMode" row>
        <v-radio value="gce" label="GCE"></v-radio>
        <v-radio value="cldy" label="CLDY"></v-radio>
        <v-radio value="custom" label="Custom"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="6" v-show="contactMode === 'custom'">
      <h5>Admin Contact</h5>
      <profile-sg
        disable-uen-lookup
        ref="adminProfileCompSg"
        :setNewProfile="newProfile"
      ></profile-sg>
    </v-col>
    <v-col cols="12">
      <v-btn
        color="primary"
        :loading="updateAdminLoading"
        @click="updateAdmin"
      >Update</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import ProfileSg from '../../components/ProfileSg.vue';

export default {
  name: 'ForceSgnicDomainAdminChange',
  components: {
    ProfileSg,
  },
  created() {
  },
  data() {
    return {
      type: 'admin',
      contactMode: 'gce',
      profileContact: this.$refs.adminProfileCompSg,
      newProfile: null,
      form: {
        domain: '',
      },
      updateAdminLoading: false,
    };
  },
  methods: {
    updateAdmin() {
      this.updateAdminLoading = true;
      this.$api.post('admin/force-sgnic-admin-contact', {
        domain: this.form.domain,
        mode: this.contactMode,
        contact: this.contactMode === 'custom' ? this.profileContact.getProfileData() : [],
        type: this.type,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Admin contact is updated successfully.',
        });
      }).finally(() => {
        this.updateAdminLoading = false;
      });
    },
  },
  watch: {
    'form.domain': {
      handler(domain) {
        if (domain.indexOf('.sg') > 0) {
          console.log(this.$refs.adminProfileCompSg);
          this.profileContact = this.$refs.adminProfileCompSg;
        }
      },
    },
    contactMode: {
      handler(contactMode) {
        if (contactMode === 'custom') {
          console.log(this.$refs.adminProfileCompSg);
          this.profileContact = this.$refs.adminProfileCompSg;
        }
      },
    },
  },
};
</script>

<style scoped>

</style>
